











































































import { gsap } from "gsap";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    TheBreadcrumb,
    CommonHeading,
    FormSearch,
    ButtonRefineBase,
    ButtonRefine
  }
})
export default class TheTemplateI extends Vue {
  @Prop({ type: Object }) sorted!: any;
  @Prop({ type: String }) filterHeading!: string;

  // isSp!: boolean;
  closeModalState!: boolean;
  search = "";
  searchUriBase: Array<string> = ["/j03/", "/j04/"];
  executeSearchFormDomAnimation = true;
  shownSearchFormState = true;
  searchFormClassName = "p-the-template-i__search--animation";
  serchFormStyle: Record<string, any> = {
    visibility: "hidden",
    opacity: 0
  };
  get isSp(){
    return globals.isLargeBreakpointWidthOfSp;
  }
  $event!: string | number;

  @Prop({ type: [String, Boolean], default: false, required: true }) heading!:
    | string
    | boolean;
  @Prop({ type: Array, default: ["search", "button"] }) indicatedItem!: Array<
    string
  >;
  @Prop({ type: String, default: "" }) searchKeyword!: string;
  @Prop({ type: String, default: "検索" }) searchPlaceholder!: string;
  @Prop({ type: Boolean, default: false }) initShownSearchFormState!: boolean;

  get indicateSearchForm() {
    const indicatedItem = this.indicatedItem;
    const keyword = "search";
    return indicatedItem.includes(keyword);
  }

  get indicateSearchButton() {
    const indicatedItem = this.indicatedItem;
    return indicatedItem.includes("searchButton");
  }

  get indicateSortedButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "sorted";
    return indicatedItem.includes(keyword);
  }

  get contentElementStyle() {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    let styleObject = {};

    if (executeSearchFormDomAnimation === false) {
      styleObject = {
        marginTop: 0
      };
    }

    return styleObject;
  }

  get widthButtonRefine() {
    return "170px";
  }

  @Watch("isSp")
  onIsSp() {
    // this.initDomElement();
    this.initSearchFormDomAnimation();
  }

  doSort($event: any) {
    this.$emit("do-sort", $event);
  }

  @Watch("shownSearchFormState")
  onShownSearchFormState() {
    this.animationSearchFormDom(this.$refs.searchFormElement);
  }

  mounted() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
  }

  created() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
    this.initSearchFormDomAnimation();
    this.initSearchKeyword();
  }

  initSearchKeyword() {
    this.search = this.searchKeyword;
  }

  // doSearch() {
  //   const { searchUriBase } = this;
  //   const max = 1;
  //   const min = 0;
  //   const ramdomNum = Math.floor(Math.random() * (max + 1 - min)) + min;
  //   const apiUri = `${searchUriBase[ramdomNum]}`;

  //   document.location.href = apiUri;
  // }
  async doSearch() {
    this.$emit("do-search", this.searchKeyword);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  switchSearchFormState() {
    this.shownSearchFormState = !this.shownSearchFormState;
  }

  initSearchFormDomAnimation() {
    const { isSp, indicateSearchButton, initShownSearchFormState } = this;
    const executeSearchFormDomAnimation = isSp && indicateSearchButton;

    this.executeSearchFormDomAnimation = executeSearchFormDomAnimation;
    this.shownSearchFormState =
      initShownSearchFormState || !executeSearchFormDomAnimation;
  }

  animationSearchFormDom(el: any, shown = this.shownSearchFormState) {
    const { isSp, executeSearchFormDomAnimation } = this;
    const { contentElement } = this.$refs;
    const speed = 0.2;

    const animationStyle = {
      formSearchElement: {
        autoAlpha: shown ? 1 : 0
      },
      contentElement: {
        marginTop:
          isSp && shown && executeSearchFormDomAnimation
            ? `${60 / 16}rem`
            : "0rem"
      }
    };

    gsap.to(el, speed, animationStyle.formSearchElement);
    gsap.to(contentElement, speed, animationStyle.contentElement);
  }
}
